module.exports = __webpack_public_path__ + "static/media/waze-logo.34a9a09e.png";